import { useMainButton } from "../tg";

type Props = {
  title: string;
  onBack: () => void;
};

// Заглушка для разделов, помеченных available=true, но ещё не реализованных
// (audio_course / lessons / daily_homework). Карточка на главном уже кликается,
// здесь юзер получает осмысленный ответ вместо «мёртвой» кнопки.
export default function SectionStub({ title, onBack }: Props) {
  // Дублируем «Назад» в MainButton — на случай если юзер не привык к Telegram BackButton.
  useMainButton({ text: "Назад", onClick: onBack });

  return (
    <div className="screen">
      <header>
        <h1>{title}</h1>
      </header>
      <div className="card">Раздел в разработке, скоро добавим.</div>
    </div>
  );
}
